import { css as f, LitElement as m, html as c, nothing as d } from "lit";
import { property as p, customElement as v } from "lit/decorators.js";
import { b as h, f as x } from "./styles-scZ6dVz-.js";
var y = Object.defineProperty, _ = Object.getOwnPropertyDescriptor, b = (n, e, a, t) => {
  for (var r = t > 1 ? void 0 : t ? _(e, a) : e, s = n.length - 1, o; s >= 0; s--)
    (o = n[s]) && (r = (t ? o(e, a, r) : o(r)) || r);
  return t && r && y(e, a, r), r;
};
let i = class extends m {
  constructor() {
    super(...arguments), this.ariaLabel = "Breadcrumb";
  }
  render() {
    return c`
      <nav aria-label=${this.ariaLabel}>
        <slot></slot>
      </nav>
    `;
  }
};
i.styles = [
  h,
  f`
      :host {
        display: block;
      }

      nav {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: var(--r5-space-2);
        color: var(--r5-text-muted);
        font-size: var(--r5-text-sm);
      }
      
      ::slotted(ark-breadcrumb-item:not(:last-child))::after {
        content: '/';
        margin-left: var(--r5-space-2);
        color: var(--r5-text-muted);
        opacity: 0.5;
      }
    `
];
b([
  p()
], i.prototype, "ariaLabel", 2);
i = b([
  v("ark-breadcrumb")
], i);
var g = Object.defineProperty, O = Object.getOwnPropertyDescriptor, u = (n, e, a, t) => {
  for (var r = t > 1 ? void 0 : t ? O(e, a) : e, s = n.length - 1, o; s >= 0; s--)
    (o = n[s]) && (r = (t ? o(e, a, r) : o(r)) || r);
  return t && r && g(e, a, r), r;
};
let l = class extends m {
  constructor() {
    super(...arguments), this.current = !1;
  }
  render() {
    return this.current || !this.href ? c`
        <span aria-current=${this.current ? "page" : d}>
          <slot></slot>
        </span>
      ` : c`
      <a href=${this.href} class="focus-ring">
        <slot></slot>
      </a>
    `;
  }
};
l.styles = [
  h,
  x,
  f`
      :host {
        display: inline-flex;
        align-items: center;
      }

      :host([current]) {
        font-weight: var(--r5-font-medium);
        color: var(--r5-text);
        pointer-events: none;
      }

      a {
        text-decoration: none;
        color: inherit;
        transition: color var(--r5-duration-fast);
        border-radius: var(--r5-radius-sm);
        cursor: pointer;
      }

      a:hover {
        color: var(--r5-text);
        text-decoration: underline;
      }
    `
];
u([
  p()
], l.prototype, "href", 2);
u([
  p({ type: Boolean, reflect: !0 })
], l.prototype, "current", 2);
l = u([
  v("ark-breadcrumb-item")
], l);
export {
  i as A,
  l as a
};
//# sourceMappingURL=ark-breadcrumb-item-wMrKmFEI.js.map
